export const FormValidationMessage: React.FC<{
  message: string;
}> = ({ message }) => (
  <div className="tw-text-base2 tw-font-bold tw-leading-[1.4] tw-text-caution-lv1">
    {message}
  </div>
);
